import { NotEnoughMoney } from '../user/not-enough-money';
import { PreCheckErrorMixin } from './pre-check-error';

export class InsufficientFundsPreCheckError extends PreCheckErrorMixin(NotEnoughMoney) {
    constructor(
        userMoney: number,
        public override stake: number /*, teaserId?: number*/,
    ) {
        super(userMoney);
        // this.slipId = typeof teaserId === 'undefined' ? null : teaserId;
    }
}
